import React from "react";
import PropTypes from "prop-types";

/**
 * ADD FILTER button which triggers the filter action
 * @param {*} props
 */
const FilterSelectAddFilterButton = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    props.onClick();
  };

  return (
    <div>
      <button
        disabled={props.disabled}
        className="filter-apply-button"
        onClick={onClick}
      >
        Add Filter
      </button>
    </div>
  );
};

FilterSelectAddFilterButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FilterSelectAddFilterButton;
